import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import UpdateWidgetClient from 'use-case/widget/update/updateWidgetClient';
import { WidgetConfigurationFieldJsonType, WidgetOptionConfigurationFieldJsonType } from 'adapter/out/client/widgets/mappers/WidgetMapper';
import UpdateWidgetCriteria from 'use-case/widget/update/updateWidgetCriteria';
import { WidgetConfigurationField, WidgetOptionConfigurationField } from 'domain/entity/widget';
import BasicEntity from 'domain/entity/basicEntity';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateWidgetClient => (criteria: UpdateWidgetCriteria) =>
    httpClient(`${baseUrl}/dashboards/widgets/${criteria.widgetId}`, {
        method: 'PUT',
        body: JSON.stringify(asJsonUpdateWidget(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then((json: BasicEntity) => ({ id: json.id }))
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asJsonUpdateWidget = (criteria: UpdateWidgetCriteria): WidgetJsonType => ({
    settings: {
        type: criteria.type as string,
        options: criteria.optionFields.map((field: WidgetOptionConfigurationField) => ({ key: field.key, value: field.value })),
    },
    configuration: {
        feature: '',
        preset: criteria.presetKey,
        fields: criteria.configurationFields.map((field: WidgetConfigurationField) => ({ key: field.key, value: field.value })),
    },
});

export type WidgetJsonType = {
    settings: {
        type: string;
        options: WidgetOptionConfigurationFieldJsonType[];
    };
    configuration: {
        feature: '';
        preset: string;
        fields: WidgetConfigurationFieldJsonType[];
    };
};
